import { useState } from 'react'
import { usePagination } from 'hooks/pagination.hook'
import { useSnackBar } from '../../../contexts/snackbar.context'
import { HttpErrorType } from '../../../types/http.type'
import { errorColor, errorMessage } from 'utils/error.util'
import { useBackdrop } from '../../../contexts/backdrop.context'
import creaService from 'services/crea.service'
import { CreasFilterRequest } from 'types/search-creas.type'
import { CreasResponse } from 'types/creas.type'

export const useCreas = () => {
  const { showSnackBar } = useSnackBar()
  const { handleBackdropOpen, handleBackdropClose } = useBackdrop()
  const {
    page,
    elements: { totalOfElements },
    pages: { handleTotalOfPages },
    elements: { handleTotalOfElements },
    handleNewPage,
  } = usePagination()
  const [creas, setCreas] = useState<CreasResponse[]>([])
  const [loaded, setLoaded] = useState(false)

  const handleBuscarCreas = async (filters: CreasFilterRequest) => {
    handleBackdropOpen()
    await creaService
      .getByFilters(filters)
      .then((response) => {
        if (response.data && response.data.content) {
          handleTotalOfPages(response.data.totalPages)
          handleTotalOfElements(response.data.totalElements)
          setCreas(response.data.content)
        }
      })
      .catch((error: HttpErrorType) => {
        showSnackBar(errorMessage(error), errorColor(error))
      })
      .finally(() => {
        setLoaded(true)
        handleBackdropClose()
      })
  }

  return {
    page,
    elements: { totalOfElements },
    creas,
    loaded,
    handleBuscarCreas,
    handleNewPage,
  }
}
